/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Recreate_Confirm_DescInputs */

const vi_order_recreate_confirm_desc = /** @type {(inputs: Order_Recreate_Confirm_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn này sẽ bị huỷ với lý do "Huỷ để tạo lại", hệ thống tạo ngay một đơn nháp mới giữ nguyên khách hàng, hàng hóa và vật tư để bạn sửa số lượng.`)
};

/**

* @param {Order_Recreate_Confirm_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_recreate_confirm_desc = /** @type {((inputs?: Order_Recreate_Confirm_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Recreate_Confirm_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_recreate_confirm_desc(inputs)
});